import { SupplyReviews } from './../models/supply-reviews';
import { Apollo, gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
const addSupplyReviewsOneMutation= gql`mutation insert_supply_reviews_one($supply_reviews: supply_reviews_insert_input!){
  insert_supply_reviews_one(object:$supply_reviews){
   id
  }
}`;
@Injectable({
  providedIn: 'root'
})
export class AddSupplyReviewsService {

  constructor(private apollo: Apollo) { }

  addSupplyReviewsOne(supply_reviews: SupplyReviews){
    return this.apollo.use('external').mutate({
      mutation: addSupplyReviewsOneMutation,
      variables: {
        supply_reviews
      }
    }).toPromise();
  }
}
